/* Luxury polish: enable scroll reveals before first paint (motion-safe, fail-open) */
(function () {
  try {
    if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      document.documentElement.classList.add('reveal-on');
    }
  } catch (e) {}
})();

// Hover-to-play logic for service videos
document.addEventListener('DOMContentLoaded', () => {
  const hoverVideos = document.querySelectorAll('.hover-video');

  hoverVideos.forEach((video) => {
    // Desktop hover
    video.addEventListener('mouseenter', () => {
      video.currentTime = 0;
      video.play().catch(() => {});
    });

    video.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
    });

    // Mobile tap: toggle play / pause
    video.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  });
});
// Catalog Filtering Script
document.addEventListener("DOMContentLoaded", () => {
  const filterButtons = document.querySelectorAll(".filter-tag");
  const items = document.querySelectorAll(".catalog-item");

  filterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      
      // update active styling
      filterButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const filter = btn.dataset.filter;

      items.forEach((item) => {
        const categories = item.dataset.category.split(" ");

        if (filter === "all" || categories.includes(filter)) {
          item.style.display = "flex"; // show item
        } else {
          item.style.display = "none"; // hide item
        }
      });
    });
  });
});
function toggleMobileMenu() {
  let menu = document.getElementById("mobileMenu");
  menu.style.display = (menu.style.display === "flex") ? "none" : "flex";
}
document.addEventListener("DOMContentLoaded", () => {
  const url = window.location.href;

  if (url.includes("contact_posted=true")) {
    const successBox = document.getElementById("contactSuccess");
    if (successBox) {
      successBox.classList.add("active");
      window.scrollTo({ top: successBox.offsetTop - 120, behavior: "smooth" });
    }
  }
});

/* Luxury polish: scroll-reveal + header elevation on scroll */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.documentElement;

  // Scroll reveal (fail-open: any problem just shows everything)
  if (root.classList.contains('reveal-on')) {
    try {
      var sel = '.section-heading, .service-grid, .featured-grid, .about-content, .about-photo, ' +
                '.pricing-grid, .reviews-marquee, .portfolio-stats, .portfolio-clients, .contact-form, .shopify-form-container, ' +
                '.product-info, .collection-grid, .collection-pagination, .cart-form, .cart-summary';
      var els = document.querySelectorAll(sel);
      if ('IntersectionObserver' in window && els.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px 12% 0px' });
        els.forEach(function (el) { io.observe(el); });
      } else {
        root.classList.remove('reveal-on');   // no observer -> reveal all
      }
    } catch (err) {
      root.classList.remove('reveal-on');      // any failure -> reveal all
    }
  }

  // Header gains subtle elevation once scrolled
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
});

/* Floating Merch button — show once scrolled past the hero */
document.addEventListener('DOMContentLoaded', function () {
  var fm = document.getElementById('floatingMerch');
  if (!fm) return;
  var toggle = function () {
    fm.classList.toggle('visible', window.scrollY > window.innerHeight * 0.7);
  };
  toggle();
  window.addEventListener('scroll', toggle, { passive: true });
  window.addEventListener('resize', toggle, { passive: true });
});

/* iPhone 17 Pro giveaway pop-out — random delay, X to close (once per session) */
(function () {
  function initPromo() {
    var popup = document.getElementById('promoPopup');
    if (!popup) return;
    try { if (sessionStorage.getItem('mdmPromoClosed') === '1') return; } catch (e) {}
    var delay = 4000 + Math.random() * 9000;   // random 4–13s
    setTimeout(function () { popup.classList.add('show'); }, delay);
    var closeBtn = document.getElementById('promoClose');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        popup.classList.remove('show');
        try { sessionStorage.setItem('mdmPromoClosed', '1'); } catch (e) {}
      });
    }
  }
  if (document.readyState !== 'loading') initPromo();
  else document.addEventListener('DOMContentLoaded', initPromo);
})();

/* Contact tab: scroll to the contact section AND the Shopify form below it.
   The form is an app block rendered after the page section, so we scroll to a
   point that shows both the contact details and the form. */
document.addEventListener('DOMContentLoaded', function () {
  function scrollToContact() {
    var contact = document.getElementById('contact');
    if (!contact) return false;
    // Prefer the actual form if it's on the page (Shopify Forms app block)
    var form = document.querySelector('.shopify-app-block form, .shopify-block form, form[action*="contact"], .contact-form');
    var target = contact;
    // If a form exists just below, aim between the two so both are visible
    if (form && form.getBoundingClientRect().top > contact.getBoundingClientRect().top) {
      target = contact;
    }
    var top = target.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }

  // Handle in-page clicks on any Contact link
  document.querySelectorAll('a[href$="#contact"], a[href="#contact"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (document.getElementById('contact')) {
        e.preventDefault();
        scrollToContact();
        history.replaceState(null, '', '#contact');
      }
    });
  });

  // Handle arriving from another page (e.g. Merch -> /#contact)
  if (window.location.hash === '#contact') {
    setTimeout(scrollToContact, 350);   // let app blocks/images settle first
  }
});

/* Subscribe pop-up (email + phone) + optional giveaway countdown */
(function () {
  function init() {
    var popup = document.getElementById('subscribePopup');
    if (!popup) return;
    var closed = false;
    try { closed = sessionStorage.getItem('mdmSubClosed') === '1'; } catch (e) {}
    var success = popup.querySelector('.subscribe-success');
    function open() { popup.classList.add('show'); }
    function close() { popup.classList.remove('show'); try { sessionStorage.setItem('mdmSubClosed', '1'); } catch (e) {} }
    if (success) { open(); }                       // show the thank-you after a successful signup
    else if (!closed) { setTimeout(open, 6000); }  // otherwise appear once per session after 6s
    var cb = document.getElementById('subscribeClose');
    var bd = document.getElementById('subscribeBackdrop');
    if (cb) cb.addEventListener('click', close);
    if (bd) bd.addEventListener('click', close);

    // Giveaway countdown (only present on the giveaway version)
    var timerEl = document.getElementById('giveawayTimer');
    if (timerEl) {
      var wrap = timerEl.closest('.giveaway-timer');
      var end = wrap ? (wrap.getAttribute('data-giveaway-end') || '').trim() : '';
      var target;
      if (end && !isNaN(Date.parse(end))) {
        target = new Date(end).getTime();
      } else {
        var start;
        try { start = localStorage.getItem('mdmGiveawayStart'); if (!start) { start = String(Date.now()); localStorage.setItem('mdmGiveawayStart', start); } }
        catch (e) { start = String(Date.now()); }
        target = parseInt(start, 10) + 5 * 24 * 60 * 60 * 1000;   // rolling 5 days
      }
      (function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { timerEl.textContent = 'Ended'; return; }
        var d = Math.floor(diff / 86400000),
            h = Math.floor(diff % 86400000 / 3600000),
            m = Math.floor(diff % 3600000 / 60000),
            s = Math.floor(diff % 60000 / 1000);
        timerEl.textContent = d + 'd ' + h + 'h ' + m + 'm ' + s + 's';
        setTimeout(tick, 1000);
      })();
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Slim "Sign Up" tab on the left opens the subscribe pop-up */
document.addEventListener('DOMContentLoaded', function () {
  var tab = document.getElementById('signupTab');
  var popup = document.getElementById('subscribePopup');
  if (tab && popup) {
    tab.addEventListener('click', function () { popup.classList.add('show'); });
  }
});

/* Header "Get Drop Alerts" button opens the subscribe pop-up */
document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById('subscribePopup');
  ['headerNotify', 'headerNotifyM'].forEach(function (id) {
    var btn = document.getElementById(id);
    if (btn && popup) btn.addEventListener('click', function () { popup.classList.add('show'); });
  });
});
